import axios from 'axios';
import store from '../store';
import { vue } from '../main';

const baseURL = process.env.VUE_APP_API_URL;

/*
    ERROR CODES

    ERROR_UNAUTHORIZED = 1847494
    ERROR_AUTH_ALREADY_AUTHENTICATED = 1847495
    ERROR_AUTH_INVALID_CREDENTIALS = 1847496
    ERROR_AUTH_NO_CHANNEL = 1847497

    ERROR_INSTANCE_OWNED_BY_OTHER = 1847498
    ERROR_INSTANCE_NOT_USED = 1847499
    ERROR_INSTANCE_INEXISTENT = 1847500
    ERROR_INSTANCE_INVALID_TITLE = 1847501
    ERROR_INSTANCE_ALREADY_LOCKED = 1847502

    ERROR_CHANNEL_INVALID = 1847503
    ERROR_CHANNEL_LIST_EMPTY = 1847504
    ERROR_CHANNEL_NO_PERMISSION = 1847505

    ERROR_MEDIA_NOT_FOUND = 1847506
    ERROR_MEDIA_LIST_UNAVAILABLE = 1847507

    ERROR_CHAPTER_INEXISTENT = 1847508

    ERROR_PARAMETER_INVALID = 1847509
    ERROR_PARAMETER_MISSING = 1847510

    ERROR_HISTORY_EMPTY = 1847511

    ERROR_SETTINGS_LIST = 1847512
    ERROR_SETTINGS_DICT = 1847513
    ERROR_SETTINGS_STRING = 1847514
    ERROR_SETTINGS_BOOL = 1847515
    ERROR_SETTINGS_INVALID_KEY = 1847516
    ERROR_SETTINGS_INVALID_FORMAT = 1847517
 */

const axiosInstance = axios.create({
  url: baseURL,
});
axiosInstance.defaults.headers.common.Authorization = store.getters.getBearer;
/*
  Request Interceptor
 */
axiosInstance.interceptors.request.use((config) => {
  vue.$Progress.start();
  return config;
}, error => Promise.reject(error));

/*
  Response Interceptor
 */
axiosInstance.interceptors.response.use((response) => {
  vue.$Progress.finish();
  return response;
}, (error) => {
  vue.$Progress.fail();

  if (error.response === undefined) {
    vue.$snotify.error(vue.$t('ERROR_SERVER_ERROR'));
    return Promise.reject(error);
  }

  /**
     * Logout Users if the HTTP Code is 403.
     * This usually means the JWT is expired / invalid.
     */
  if (error.response.status === 403) {
    vue.$store.dispatch('logout')
      .then(() => {
        vue.$snotify.info(vue.$t('UI_INFO_LOGGED_OUT_INACTIVITY'));
        vue.$router.push({ name: 'login' });
      });
  }
  if (error.response.status === 502) {
    vue.$snotify.error(vue.$t('ERROR_BAD_GATEWAY'));
  }

  // if (error.response.status === 500) {
  //     vue.$snotify.error(vue.$t('ERROR_SERVER_ERROR'));
  // }
  /**
     * Return a No Permission alert on 403.
     * This usually means that a user is not authorized to access the requested data.
     */
  if (error.response.status === 401) {
    vue.$snotify.error(vue.$t('UI_GENERAL_ERROR_NO_PERMISSION'));
  }

  if (error.response.status === 400) {
    if (error.response.data) {
      vue.$snotify.error(vue.$t(vue.getKeyByErrorCode(error.response.data.error)));
    }
  }

  return Promise.reject(error);
});

export default axiosInstance;
